import axios from "axios";

export const redirectToOracleCommerce = async (email) => {
  try {
    const { data } = await axios.post(
      process.env.REACT_APP_OCC_PORTAL_SWAP_ENV,
      {
        email,
      }
    );
  
    const {
      data: { shopperProfileId, access_token },
    } = data;
  
    const form = document.createElement("form");
    form.setAttribute("method", "POST");
    form.setAttribute("target", "_blank");
    form.setAttribute("action", process.env.REACT_APP_OCC_PORTAL_SWAP);
  
    var inputToken = document.createElement("input");
    inputToken.setAttribute("name", "cc-shopper-behalf-token");
    inputToken.setAttribute("id", "cc-shopper-behalf-token");
    inputToken.setAttribute("value", access_token);
    inputToken.setAttribute("type", "hidden");
    form.appendChild(inputToken);
  
    var inputRedirectUrl = document.createElement("input");
    inputRedirectUrl.setAttribute("name", "cc-shopper-agent-redirect-url");
    inputRedirectUrl.setAttribute("id", "cc-shopper-agent-redirect-url");
    inputRedirectUrl.setAttribute(
      "value",
      process.env.REACT_APP_OCC_KEYCLOAK_CONN + shopperProfileId
    );
    inputRedirectUrl.setAttribute("type", "hidden");
    form.appendChild(inputRedirectUrl);
  
    var inputOrganizationId = document.createElement("input");
    inputOrganizationId.setAttribute("name", "cc-shopper-organizationId-value");
    inputOrganizationId.setAttribute("id", "cc-shopper-organizationId-value");
    inputOrganizationId.setAttribute("value", "");
    inputOrganizationId.setAttribute("type", "hidden");
    form.appendChild(inputOrganizationId);
  
    var inputPriceListGroupId = document.createElement("input");
    inputPriceListGroupId.setAttribute(
      "name",
      "cc-shopper-priceListGroupId-value"
    );
    inputPriceListGroupId.setAttribute("id", "cc-shopper-priceListGroupId-value");
    inputPriceListGroupId.setAttribute("value", "");
    inputPriceListGroupId.setAttribute("type", "hidden");
    form.appendChild(inputPriceListGroupId);
  
    document.querySelectorAll("body")[0].append(form);
  
    form.submit();
  } catch (error) {
    return error
  }
};